// extracted by mini-css-extract-plugin
export default {"form":"QuoteForm_form__BhnZk","loading":"QuoteForm_loading__B4Nlx","control":"QuoteForm_control__VP4Jh","actions":"QuoteForm_actions__57M2K"};